import axios from "axios";
import { useState } from "react";
import { ClientOption } from "../../config/clientOption";
import { useNavigate } from "react-router";
import { IconX } from "@tabler/icons-react";

const ModalSearch = () => {
    let [productCategorys, setProducts] = useState<any>([])
    const navigate = useNavigate();
    const searchValue = (values: any) => {
        let value = values
        axios.get(`${process.env.REACT_APP_API_URL}products/search?q=${value}`, ClientOption)
            .then((response) => {
                console.log(response)
                setProducts(response.data.data.products)
            })
            .catch((error) => [
                console.log(error)
            ])
    }
    const handleNavigate = (slug: string) => {
        navigate(`/products/detail/${slug}`);
        const closeModalButton: any = document.getElementById("close-modal-s");
        if (closeModalButton) {
            closeModalButton.click();
        }
    };
    return (
        <>
            <div className="modal fade" id="modal-search">
                <div className="modal-dialog modal-fullscreen-sm-down">
                    <div className="modal-content">
                        <div className="modal-header d-md-none d-flex justify-content-between">
                            <h6 className="mb-0 fw-bold">
                                جست و جو
                            </h6>
                            <IconX data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <div className="d-flex justify-content-between">
                                <input onKeyUp={(e: any) => searchValue(e.target.value)} placeholder="به دنبال چه چیزی می گردید؟" className="form-control w-100 font-medium-lg rounded rounded-5 py-2"></input>
                                <button className="d-none" hidden id="close-modal-s" data-bs-dismiss="modal"></button>
                            </div>
                            <ul className="list-group py-3 px-0">
                                {productCategorys?.map((item: any) => (
                                    <>
                                        <li className="list-group-item">
                                            <div onClick={() => handleNavigate(item.slug)}>
                                                <div className="d-flex align-items-center">
                                                    <img alt="icon" src={item.primary_image} style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                                                    <div className="text-split font-medium-lg ms-2">
                                                        {item.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalSearch;